/**
 * Iter-150 · Red Team Fix 3 — ExplorePlatformTile.
 *
 * Shared internal tile that opens the public /demo experience in a new
 * tab. Replaces the footer "Explore the Platform" CTA. Mounted inside
 * the Sales Command Center and the Customer Service Command Center so
 * reps can walk prospects through the platform live.
 */
import { Rocket, ExternalLink } from 'lucide-react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';

export default function ExplorePlatformTile({ testId = 'explore-platform-tile' }) {
  const openDemo = () => window.open('/demo', '_blank', 'noopener,noreferrer');
  return (
    <Card
      className="p-5 border-2"
      style={{ backgroundColor: '#0f0f0f', borderColor: '#22d3ee' }}
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-[0.28em] font-black" style={{ color: '#22d3ee' }}>
            NECS Platform Demo · Public
          </p>
          <h3 className="text-lg font-black text-white" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            Explore the Platform
          </h3>
          <p className="text-xs text-zinc-400 mt-1 max-w-xl">
            Walk prospects through the full NECS Integrated Facility Care
            experience — 12 commercial verticals, the quote engine, sample
            facility profiles, customer portal and multifamily resident
            preview. Sample data · no auth required.
          </p>
          <ul className="mt-3 text-[11px] text-zinc-300 space-y-1">
            <li>• 12 verticals grouped by Standard Commercial + Strategic Enterprise</li>
            <li>• 18-step quote engine walkthrough with zones and pricing inputs</li>
            <li>• Customer portal preview: contracts · invoices · payments</li>
          </ul>
        </div>
        <Button
          onClick={openDemo}
          className="font-bold"
          style={{ backgroundColor: '#22d3ee', color: '#0a0a0a' }}
          data-testid={`${testId}-open`}
        >
          <Rocket className="h-4 w-4 mr-2" />
          Open Demo
          <ExternalLink className="h-3.5 w-3.5 ml-2" />
        </Button>
      </div>
    </Card>
  );
}
